import { render } from "./LevensverhaalView.vue?vue&type=template&id=13af78a5"
import script from "./LevensverhaalView.vue?vue&type=script&lang=js"
export * from "./LevensverhaalView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__